import { render, staticRenderFns } from "./PreferredDealer.vue?vue&type=template&id=2151465c&scoped=true"
import script from "./PreferredDealer.vue?vue&type=script&lang=js"
export * from "./PreferredDealer.vue?vue&type=script&lang=js"
import style0 from "./PreferredDealer.vue?vue&type=style&index=0&id=2151465c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2151465c",
  null
  
)

export default component.exports